import { Box, Typography, Stack, IconButton } from '@mui/material';
import { useState } from 'react';
import Iconify from './Iconify';

export default function ShareButtons({ eventID }) {
  const shareUrl = `https://choptonticket.com/event/${eventID}?ref=share`;
  const title = "Découvrez cet événement sur Choptonticket !";
  const hashtag = "#choptonticket";

  const handleShareClick = (platform) => {
    let url = '';

    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}&hashtags=${hashtag.replace('#', '')}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(`${title  } ${  shareUrl}`)}`;
        break;
      case 'email':
        url = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareUrl)}`;
        break;
      default:
        break;
    }

    window.open(url, '_blank');
  };

  return (
    <Box paddingX={1}>
      <Typography variant="body2"><strong>Partager sur</strong></Typography>
      <Stack direction="row" spacing={1}>
        <IconButton onClick={() => handleShareClick('facebook')}>
          <Iconify icon='logos:facebook' />
        </IconButton>
        <IconButton onClick={() => handleShareClick('twitter')}>
          <Iconify icon='fa6-brands:x-twitter' />
        </IconButton>
        <IconButton onClick={() => handleShareClick('linkedin')}>
          <Iconify icon='skill-icons:linkedin' />
        </IconButton>
        <IconButton onClick={() => handleShareClick('whatsapp')}>
          <Iconify icon='logos:whatsapp-icon' />
        </IconButton>
        <IconButton onClick={() => handleShareClick('email')}>
          <Iconify icon='fluent-color:mail-20' />
        </IconButton>
      </Stack>
    </Box>
  );
}
